var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnitPriceReduced(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    rx: 5,
    fill: "#FDEDCA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7499 5H13.5545C13.2109 5 12.7305 5.19911 12.4877 5.44176L5.36477 12.5646C4.87841 13.0504 4.87841 13.8469 5.36477 14.3322L10.6683 19.6356C11.1536 20.1214 11.9493 20.1214 12.4353 19.635L19.5582 12.5132C19.8009 12.2706 20 11.7895 20 11.4466V6.25005C20 5.56268 19.4373 5 18.7499 5ZM16.2498 10C15.5594 10 14.9998 9.43977 14.9998 8.74998C14.9998 8.05905 15.5594 7.49992 16.2498 7.49992C16.9402 7.49992 17.5 8.05905 17.5 8.74998C17.5001 9.43977 16.9402 10 16.2498 10Z",
    fill: "#FCAA0B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitPriceReduced);
export default __webpack_public_path__ + "static/media/unit-price-reduced.507af99e.svg";
export { ForwardRef as ReactComponent };